"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Styling_1 = require("../../Styling");
var GlobalClassNames = {
    root: 'ms-ExpandingCard-root',
    compactCard: 'ms-ExpandingCard-compactCard',
    expandedCard: 'ms-ExpandingCard-expandedCard',
    expandedCardScroll: 'ms-ExpandingCard-expandedCardScrollRegion'
};
function getStyles(props) {
    var theme = props.theme, needsScroll = props.needsScroll, expandedCardFirstFrameRendered = props.expandedCardFirstFrameRendered, compactCardHeight = props.compactCardHeight, expandedCardHeight = props.expandedCardHeight, className = props.className;
    var palette = theme.palette;
    var classNames = Styling_1.getGlobalClassNames(GlobalClassNames, theme);
    return {
        root: [
            classNames.root,
            {
                width: '340px',
                pointerEvents: 'none',
                boxShadow: '0 0 20px rgba(0, 0, 0, .2)',
                border: 'none',
                selectors: (_a = {},
                    _a[Styling_1.HighContrastSelector] = {
                        border: '1px solid WindowText'
                    },
                    _a)
            },
            className
        ],
        compactCard: [
            classNames.compactCard,
            {
                pointerEvents: 'auto',
                position: 'relative',
                height: compactCardHeight
            }
        ],
        expandedCard: [
            classNames.expandedCard,
            {
                height: '1px',
                overflowY: 'hidden',
                pointerEvents: 'auto',
                transition: 'height 0.467s cubic-bezier(0.5, 0, 0, 1)',
                selectors: {
                    ':before': {
                        content: '""',
                        position: 'relative',
                        display: 'block',
                        top: '0',
                        left: '24px',
                        width: '292px',
                        height: '1px',
                        backgroundColor: palette.neutralLighter
                    }
                }
            },
            expandedCardFirstFrameRendered && {
                height: expandedCardHeight
            }
        ],
        expandedCardScroll: [
            classNames.expandedCardScroll,
            needsScroll && {
                height: '100%',
                boxSizing: 'border-box',
                overflowY: 'auto'
            }
        ]
    };
    var _a;
}
exports.getStyles = getStyles;
//# sourceMappingURL=ExpandingCard.styles.js.map


//////////////////
// WEBPACK FOOTER
// ./~/office-ui-fabric-react/lib-commonjs/components/HoverCard/ExpandingCard.styles.js
// module id = 1059
// module chunks = 0